export default __webpack_public_path__ + "static/media/soesvinget-property-01.e8677cfd.jpg";